import orderHistoryTemplate from './order-history.html';
import CommonApp from '../../app.js';
import {OrderHistoryService} from '../../services/order-history-service';
import {OrderHistoryDetailsService} from '../../services/order-history-details-service';
import {strings} from '../../../util/strings.js';
import {configManager} from '../../../util/config-manager/config-manager';
import {AccountConfigManager} from '../../../util/config-manager/AccountConfigManager';

CommonApp.module.service('strings', function() {
    return strings;
});
CommonApp.module.service('AccountConfigManager', function() {
    return AccountConfigManager;
});
CommonApp.module.service('configManager', function() {
    return configManager;
});

var OrderHistoryController = function($sce, $scope, $http, $q, addressFormatterFactory, strings, configManager, AccountConfigManager) {
    var self = this;

    self.accountConfigManager = AccountConfigManager.getConfig(configManager);

    var beginDate = '';

    var addressFormatter = addressFormatterFactory.getAddressFormatter(self.countryCode);

    self.orderDetails = {};
    self.addressDetails = {};
    self.monthRanges = [{value: 0, name: strings.get('tdc_pleaseSelectRange')},
        {value: 3, name: strings.get('tdc_3months')},
        {value: 6, name: strings.get('tdc_6months')},
        {value: 12, name: strings.get('tdc_12months')}];
    self.monthRangeSelected = self.monthRanges[0];
    self.orderRanges = [{value: 'OrderDate', name: strings.get('tdc_orderHistoryDate')},
        {value: 'Status', name: strings.get('tdc_orderHistoryStatus')},
        {value: 'Channel', name: strings.get('tdc_orderHistoryChannel')}];
    self.orderRangeSelected = self.orderRanges[0];
    self.propertyName = 'OrderDate';
    self.orderHistoryDetailsConfigs = '';
    self.reverse = true;

    self.showDetails = false;

    self.changedValue = function(range) {
        var today = new Date();
        today.setMonth(today.getMonth() - range);
        var dd = today.getDate();
        if (dd < 10) {
            dd = dd.toString();
            dd = '0' + dd;
        } else {
            dd = dd.toString();
        }
        var mm = today.getMonth() + 1;
        if (mm < 10) {
            mm = mm.toString();
            mm = '0' + mm;
        } else {
            mm = mm.toString();
        }
        var yyyy = today.getFullYear();
        yyyy = yyyy.toString();

        beginDate = yyyy + mm + dd;
        self.changeOrderHistory();
    };

    self.initOrderHistory = function() {
        loadOrderHistoryDetailsConfigs();
        self.monthRangeSelected.value = 0;
        self.changedValue(3);
    };

    self.changeOrderHistory = function() {
        var orderHistory = OrderHistoryService($http, $q, self.accountConfigManager, beginDate).getOrderHistoryForAccount();
        orderHistory.then(function(response) {
            self.history = response.data.SalesOrderStatusResponse.OrderStatus;
        });
    };

    self.sortBy = function(sortOn) {
        if (self.propertyName === sortOn) {
            self.reverse = !self.reverse;
        } else {
            self.propertyName = sortOn;
        }
    };

    self.scrollToArea = function(id) {
        var target = document.getElementById(id);
        if (target !== null) {
            setTimeout(function() {
                document.getElementById(id).scrollIntoView(true);
            }, 100);
        }
    };

    var loadOrderHistoryDetailsConfigs = function() {
        self.translations = {
            orderHistoryDetails: strings.get('tdc_orderHistoryDetails'),
            orderHistoryTrackingText: strings.get('tdc_orderHistoryTrackingText'),
            volumesGenealogy: strings.get('tdc_volumesGenealogy'),
            print: strings.get('tdc_print'),
            orderHistoryDate: strings.get('tdc_orderHistoryDate'),
            orderHistoryOrderNumber: strings.get('tdc_orderHistoryOrderNumber'),
            orderHistoryTotal: strings.get('tdc_orderHistoryTotal'),
            orderHistoryPSV: strings.get('tdc_orderHistoryPVS'),
            orderHistoryStatus: strings.get('tdc_orderHistoryStatus'),
            orderHistoryChannel: strings.get('tdc_orderHistoryChannel'),
            orderDetailsDate: strings.get('tdc_orderDetailsDate'),
            orderDetailsOrderNumber: strings.get('tdc_orderDetailsOrderNumber'),
            orderDetailsChannel: strings.get('tdc_orderDetailsChannel'),
            orderDetailsStatus: strings.get('tdc_orderDetailsStatus'),
            orderDetailsDescription: strings.get('tdc_orderDetailsDescription'),
            orderDetailsSKU: strings.get('tdc_orderDetailsSKU'),
            orderDetailsQty: strings.get('tdc_orderDetailsQty'),
            orderDetailsUnitPrice: strings.get('tdc_orderDetailsUnitPrice'),
            orderDetailsPSV: strings.get('tdc_orderDetailsPSV'),
            orderDetailsTotal: strings.get('tdc_orderDetailsTotal'),
            orderDetailsSubTotal: strings.get('tdc_orderDetailsSubTotal'),
            orderDetailsShipping: strings.get('tdc_orderDetailsShipping'),
            orderDetailsTax: strings.get('tdc_orderDetailsTax'),
            orderDetailsPaymentInfo: strings.get('tdc_orderDetailsPaymentInfo'),
            orderDetailsShippingAddress: strings.get('tdc_orderDetailsShippingAddress'),
            orderDetailsShippingMethod: strings.get('tdc_orderDetailsShippingMethod'),
            orderDetailsShippingMethodDays: strings.get('tdc_orderDetailsShippingMethodDays'),
            orderDetailsReturnToHistory: strings.get('tdc_orderDetailsReturnToHistory'),
            orderDetailsCompanyInfo: strings.get('tdc_orderDetailsCompanyInfo')
        };
    };

    self.getDetails = function(searchParam) {
        self.showDetails = true;
        var orderHistoryDetails = OrderHistoryDetailsService($http, $q, self.accountConfigManager, searchParam).getOrderHistoryDetails();
        orderHistoryDetails.then(function(response) {
            self.orderDetails = response.data.SalesOrderResponse.SalesOrderDetail;
            var address = self.addressMapper(self.orderDetails.Shipping.ShippingParty[1].ShippingAddress.Address);
            address = addressFormatter.formatFromService(address);
            self.addressDetails = address;
            self.addressDisplay = addressFormatter.displayForProfile(address);
        });
    };

    self.addressMapper = function(address) {
        var mappedAddress = {};
        mappedAddress.line1 = address.Street1;
        mappedAddress.line2 = address.Street2;
        mappedAddress.city = address.City;
        mappedAddress.district = address.District;
        mappedAddress.region = address.Region;
        mappedAddress.postalCode = address.PostalCode;
        mappedAddress.country = address.CountryCode;
        return mappedAddress;
    };

    self.print = function(id) {
        var tableToPrint = document.getElementById(id).innerHTML;
        var newWin = window.open('');
        newWin.document.write('<style>\n' +
            '    table#orderHistory {\n' +
            '        width: 100%;\n' +
            '        font-size: 14px;\n' +
            '        border-bottom:1em solid #e1e1e1;\n' +
            '    }\n' +
            '\n' +
            '    .mobileOnly {\n' +
            '        display: none;\n' +
            '    }\n' +
            '    .pageTitle{\n' +
            '        text-align:left;\n' +
            '        font-size: 20px;\n' +
            '        border-bottom: 1px solid #E1E1E1;\n' +
            '        font-weight: normal;\n' +
            '        line-height: 2.0em;\n' +
            '        margin-bottom: 1em;\n' +
            '    }\n' +
            '\n' +
            '    table#orderHistory thead tr th {\n' +
            '        border-left: 1px solid #fff;\n' +
            '        background-color: #e1e1e1;\n' +
            '        height: 23px;\n' +
            '        line-height: 23px;\n' +
            '    }\n' +
            '\n' +
            '    table#orderHistory tbody tr:nth-child(odd) {\n' +
            '        background-color: #f0f0f0;\n' +
            '    }\n' +
            '\n' +
            '    table#orderHistory tbody tr td {\n' +
            '        text-align: center;\n' +
            '        height: 23px;\n' +
            '        line-height: 23px;\n' +
            '    }\n' +
            '\n' +
            '    table#orderHistory tbody tr td label{\n' +
            '        display: none;\n' +
            '    }\n' +
            '\n' +
            '    .custom-class{\n' +
            '        background-color: pink !important;\n' +
            '    }\n' +
            '\n' +
            '    .default-color{\n' +
            '        background-color: white;\n' +
            '    }\n' +
            '\n' +
            '    select{\n' +
            '        font-size: 16px;\n' +
            '        border:1px solid #6d7073;\n' +
            '        -webkit-border-radius: 0px;\n' +
            '        -moz-border-radius: 0px;\n' +
            '        border-radius: 0px;\n' +
            '        height:40px;\n' +
            '        padding:0 .25em;\n' +
            '        color: #6d7073;\n' +
            '        margin:0.25em;\n' +
            '        background:#fff url(\'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAALCAYAAACQy8Z9AAAACXB' +
            'IWXMAAAsSAAALEgHS3X78AAABB0lEQVQoFZ2SPU7DQBBGH+EA5AaEKiU+gitEutwAcgCbteweDrDSJnsBQkdJh6DKEZIbwAVQIlHQ' +
            'GU00Cytg88NIa40+j5+/mVnatl2fwtRZyP9zClN3C1P3JD+QR1k1N8A1cAcY7+ySPaKsmi4wA06B0eHb6r0HjAF5kQGDx6fn+8H52' +
            'ccu2LJqMgX2VTrpeGdfFLZQUf421+JtwFyBxypJp/m6fb5bEMcXWrACht7ZWQJ4CdxG0sQ7ayT5gkbFAr6KpJF3drpPzS/oJhe7dv' +
            'MnNJrXA3AUzSvTmUu8KnD+89skVMECEXBYRAhZap66ep0kEVAX8c0IjpPArU4jx2GWy7DhZACfMo+lXs2CFWQAAAAASUVORK5C' +
            'YII=\') no-repeat 95% 50%;\n' +
            '    }\n' +
            '\n' +
            '    button{\n' +
            '        border:1px solid #008ab0;\n' +
            '        color:#008ab0;\n' +
            '        -webkit-border-radius: 3px;\n' +
            '        -moz-border-radius: 3px;\n' +
            '        border-radius: 3px;\n' +
            '        background-color:#fff;\n' +
            '        padding:0 1em;\n' +
            '    }\n' +
            '    @media screen and (max-width: 768px) {\n' +
            '        table#orderHistory tbody tr{\n' +
            '            border-bottom:1px solid #cccccc;\n' +
            '        }\n' +
            '        table#orderHistory tbody tr td {\n' +
            '            display: block;\n' +
            '            width: 100%;\n' +
            '            text-align: left;\n' +
            '            height: 40px;\n' +
            '            line-height: 40px;\n' +
            '        }\n' +
            '        table#orderHistory tbody tr td:last-child{\n' +
            '            border-bottom:1px solid #cccccc;\n' +
            '            padding-bottom:30px;\n' +
            '            margin-bottom:20px;\n' +
            '        }\n' +
            '        button{\n' +
            '            font-size:16px;\n' +
            '        }\n' +
            '        button.viewOrderButton{\n' +
            '            border:1px solid #6d7073;\n' +
            '            color:#6d7073;\n' +
            '            height:40px;\n' +
            '            width:100%;\n' +
            '        }\n' +
            '        #mDateSearch{\n' +
            '            display: flex;\n' +
            '            flex-direction: row;\n' +
            '            flex-wrap: nowrap;\n' +
            '        }\n' +
            '        select{\n' +
            '            width: 0;\n' +
            '            flex-grow: 1;\n' +
            '        }\n' +
            '        table#orderHistory tbody tr:nth-child(odd) {\n' +
            '            background-color: #fff;\n' +
            '        }\n' +
            '\n' +
            '        table#orderHistory tbody tr td label{\n' +
            '            display: inline-block;\n' +
            '            font-weight: bold;\n' +
            '            text-transform:uppercase;\n' +
            '            width:50%;\n' +
            '        }\n' +
            '\n' +
            '        .desktopOnly {\n' +
            '            display: none;\n' +
            '        }\n' +
            '\n' +
            '        .mobileOnly {\n' +
            '            display: unset;\n' +
            '        }\n' +
            '\n' +
            '    }\n' +
            '</style>');
        newWin.document.write(tableToPrint);
        newWin.print();
        newWin.close();
    };
};

OrderHistoryController.$inject = ['$sce', '$scope', '$http', '$q', 'addressFormatterFactory', 'strings', 'configManager', 'AccountConfigManager'];

CommonApp.module.component('nsOrderHistory', {
    template: orderHistoryTemplate,
    bindings: {
        orderHistoryConfigs: '=',
        countryCode: '=',
        isRetail: '='
    },
    controller: OrderHistoryController,
    controllerAs: 'ctrl'
});



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/components/order-history/order-history.js
// module id = 239
// module chunks = 0